import SandboxSwitcher, { SandboxContext } from "@/layout/Nav/SandboxSwitcher"
import { DefaultText } from "@/UI"
import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTranslation } from "react-i18next"
import { useContext } from "react"

const SandboxDisclaimer: React.FC<{
  withToggle?: boolean
}> = ({ withToggle = false }) => {
  const { t } = useTranslation()
  const sandbox = useContext(SandboxContext)

  return (
    <div className="flex items-center w-full">
      <FontAwesomeIcon icon={faCircleInfo as IconProp} className="h-3 mr-2" />
      <DefaultText>
        {sandbox.enabled
          ? t("developers.SandboxDisclaimer.viewingTestKeys")
          : t("developers.SandboxDisclaimer.viewingLiveKeys")}
      </DefaultText>
      {withToggle && (
        <div className="ml-auto">
          <SandboxSwitcher />
        </div>
      )}
    </div>
  )
}

export default SandboxDisclaimer
